var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "zoom",
    width: 16,
    height: 16,
    viewBox: "0 0 100 100",
    className: "icon-size24 mr16 ng-star-inserted",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.666,
    x2: 76.334,
    y1: 95.612,
    y2: 4.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0845bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0b5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f90ee"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient)}.cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_ZM_container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "container",
    d: "M100 50c0 5.347-.43 10.59-1.25 15.702-2.72 16.923-16.125 30.329-33.048 33.047C60.589 99.57 55.346 100 50 100s-10.59-.43-15.702-1.25C17.375 96.03 3.97 82.624 1.251 65.701.43 60.59 0 55.347 0 50s.43-10.59 1.25-15.702C3.97 17.375 17.376 3.97 34.299 1.251 39.411.43 44.653 0 50 0s10.59.43 15.702 1.25C82.625 3.97 96.03 17.376 98.749 34.299A98.946 98.946 0 0 1 100 50Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ZM_wordmark",
    d: "M29.862 57.657H17.46c-.87 0-1.648-.52-1.98-1.324s-.151-1.72.464-2.336l8.591-8.591h-6.157a3.063 3.063 0 0 1-3.063-3.063h11.438c.87 0 1.648.52 1.981 1.323.333.804.15 1.721-.464 2.337l-8.592 8.591H26.8a3.063 3.063 0 0 1 3.063 3.063Zm54.824-9.571a5.98 5.98 0 0 0-5.972-5.973 5.958 5.958 0 0 0-4.441 1.984 5.958 5.958 0 0 0-4.441-1.984 5.98 5.98 0 0 0-5.973 5.973v9.571a3.063 3.063 0 0 0 3.063-3.063v-6.508c0-1.605 1.305-2.91 2.91-2.91s2.91 1.305 2.91 2.91v6.508a3.063 3.063 0 0 0 3.062 3.063v-9.571c0-1.605 1.305-2.91 2.91-2.91s2.91 1.305 2.91 2.91v6.508a3.063 3.063 0 0 0 3.062 3.063v-9.571ZM62.328 50a7.887 7.887 0 1 1-15.774 0 7.887 7.887 0 0 1 15.774 0Zm-3.063 0a4.824 4.824 0 1 0-9.648 0 4.824 4.824 0 0 0 9.648 0Zm-13.936 0a7.887 7.887 0 1 1-15.773 0 7.887 7.887 0 0 1 15.773 0Zm-3.063 0a4.824 4.824 0 1 0-9.647 0 4.824 4.824 0 0 0 9.647 0Z",
    className: "cls-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.94b2a1028a000652ab30d06e8f901aa1.svg";
export { ForwardRef as ReactComponent };